import styled, { css } from 'styled-components';
import { COVER_IMAGE_HEIGHT, LOGO_HEIGHT, LOGO_LEFT } from '../styles';

export const Container = styled.div`
    position: absolute;
    top: ${COVER_IMAGE_HEIGHT - LOGO_HEIGHT / 2}px;
    left: ${LOGO_LEFT}px;
    border-radius: ${LOGO_HEIGHT / 2}px;
    overflow: hidden;
    box-shadow: 0 0 0 3px ${p => p.theme.c.active};
    box-sizing: border-box;
    img {
        display: block;
    }

    ${p => p.theme.xs(css`
        left: 50%;
        transform: translateX(-50%);
    `)}
`;